'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function CallbackNotifier(callback) {
    this.callback = callback;
}

_base2['default'].extend(CallbackNotifier, {
    notify: function notify(message) {
        return this.callback(message);
    }
});

exports['default'] = CallbackNotifier;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/notifiers/callback.js
 ** module id = 691
 ** module chunks = 0 1
 **/